module.exports = __webpack_public_path__ + "static/img/ent-detail-90.918efbd.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-detail-90.jpg
// module id = wRjH
// module chunks = 51